<template>
  <div class="home">
		<Header/>
		<router-view></router-view>
		<Footer/>
	</div>
</template>

<script>
import Header from '../shared/Header.vue';
import Footer from '../shared/Footer.vue';

export default {
	components: { Header, Footer }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/home/Home.vue